import { render } from "./RatingView.vue?vue&type=template&id=4c8a4b5b&scoped=true"
import script from "./RatingView.vue?vue&type=script&lang=js"
export * from "./RatingView.vue?vue&type=script&lang=js"

import "./RatingView.vue?vue&type=style&index=0&id=4c8a4b5b&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8a4b5b"]])

export default __exports__